import memoizeOne from 'memoize-one';

function computeLength(file: File): Promise<number> {
  return new Promise((resolve) => {
    const objectURL = URL.createObjectURL(file);
    const audio = new Audio(objectURL);
    audio.addEventListener(
      'canplaythrough',
      () => {
        URL.revokeObjectURL(objectURL);
        resolve(audio.duration ?? 0);
      },
      false
    );
  });
}

function delay(): Promise<number> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(0), 10000);
  });
}

export async function getAudioLength(file: File) {
  const length = await Promise.race([computeLength(file), delay()]);
  return Math.round(length * 100) / 100;
}

function computeLengthByUrl(url: string): Promise<number> {
  return new Promise((resolve) => {
    const audio = new Audio(url);
    audio.addEventListener(
      'canplaythrough',
      () => {
        resolve(audio.duration ?? 0);
      },
      false
    );
  });
}

export const getAudioLengthByUrl = memoizeOne(async (url: string) => {
  const length = await Promise.race([computeLengthByUrl(url), delay()]);
  return Math.round(length * 100) / 100;
});
